import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { Checkbox, FormControlLabel } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import Colors from '../colors';
import FilterAccordion from './FilterAccordion';
import ModalButton from './modals/Buttons/normal/ModalButton';

function FormsFilters({ setIncidentFilters, setStartDateFilter, setEndDateFilter, isAdmin, setFormCreatorFilter }) {
    const incidentCheckboxOptions = ['Near Miss', 'Incident'];
    const [incidentCheckedValues, setIncidentCheckedValues] = useState(new Array(incidentCheckboxOptions.length).fill(false));
    const [appliedIncidentFilters, setAppliedIncidentFilters] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [appliedFormCreatorFilter, setAppliedFormCreatorFilter] = useState('current-user');
    const [isExpanded, setIsExpanded] = useState(false);

    const handleAccordionCollapse = () => {
        setIsExpanded(false);
    };

    const handleIncidentCheckboxChange = (event, index, option) => {
        const newCheckedValues = [...incidentCheckedValues];
        newCheckedValues[index] = event.target.checked;
        setIncidentCheckedValues(newCheckedValues);
        if (event.target.checked) {
            setAppliedIncidentFilters((prevArray) => [...prevArray, option]);
        } else {
            setAppliedIncidentFilters((prevArray) => prevArray.filter((item) => item !== option))
        }
    };

    const handleStartDateChange = (event) => {
        try {
            setStartDate(event.toLocaleString())
        } catch (err) {
            console.log(err);
        }
    }

    const handleEndDateChange = (event) => {
        try {
            setEndDate(event.toLocaleString())
        } catch (err) {
            console.log(err);
        }
    }

    const handleApply = () => {
        setIncidentFilters(appliedIncidentFilters);
        setStartDateFilter(startDate);
        setEndDateFilter(endDate);
        setFormCreatorFilter(appliedFormCreatorFilter);

        // Collapse filter accordion
        handleAccordionCollapse();
    }

    const handleClear = async () => {
        // Reset all values
        setIncidentCheckedValues(new Array(incidentCheckboxOptions.length).fill(false));
        setAppliedIncidentFilters([]);
        setStartDate('');
        setEndDate('');
        setAppliedFormCreatorFilter('current-user');

        // Reset in TailgateForm.js
        setIncidentFilters([]);
        setStartDateFilter('');
        setEndDateFilter('');
        setFormCreatorFilter('current-user');

        // Collapse filter accordion
        handleAccordionCollapse();
    }

    const FilterButton = styled(FormControlLabel)(() => ({
        boxSizing: 'border - box',
        background: Colors.white,
        border: `1px solid ${Colors.green}`,
        borderRadius: '20px',
        width: 'fit-content',
        paddingRight: '15px',
    }));

    const FilterSectionContainer = styled('div')(() => ({
        display: 'flex',
        flexWrap: 'wrap',
        padding: '10px 0px 10px 10px',
        gap: '10px',
    }));

    const checkboxStyle = {
        fontSize: 20,
        borderRadius: '50%',
    }

    const FilterSectionLabel = styled('h3')(() => ({
        fontFamily: 'Jost',
        fontWeight: '600',
        fontSize: '13px',
        letterSpacing: '0.15em',
        textTransform: 'uppercase',
        color: Colors.darkGray,
        display: 'flex',
        marginTop: '0px',
        marginBottom: '0px',
    }));

    const ButtonContainer = styled('div')(() => ({
        display: 'flex',
        gap: '15px',
        marginTop: '10px',
    }))

    return (
        <FilterAccordion isExpanded={isExpanded} setIsExpanded={setIsExpanded}>
            <FilterSectionLabel>
                {'Near Misses / Incidents'}
            </FilterSectionLabel>
            <FilterSectionContainer>
                {incidentCheckboxOptions.map((option, index) => (
                    <FilterButton
                        key={index}
                        control={
                            <Checkbox
                                icon={
                                    <CircleOutlinedIcon
                                        style={checkboxStyle}
                                        sx={{ color: Colors.green }}
                                    />
                                }
                                checkedIcon={
                                    <CheckCircleOutlineOutlinedIcon
                                        style={checkboxStyle}
                                        sx={{ backgroundColor: Colors.green, color: "white" }}
                                    />
                                }
                                onChange={(event) => handleIncidentCheckboxChange(event, index, option)}
                                checked={incidentCheckedValues[index]}
                            />
                        }
                        label={
                            <Typography
                                sx={{
                                    fontFamily: "Jost",
                                    marginLeft: "20px",
                                    fontWeight: "400",
                                    fontSize: "15px",
                                    textTransform: "capitalize",
                                }}
                            >
                                {option}
                            </Typography>
                        }
                    />
                ))}
            </FilterSectionContainer>

            <FilterSectionLabel>{'Date'}</FilterSectionLabel>
            <FilterSectionContainer>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                        label={'Start Date'}
                        closeOnSelect={true}
                        minDate={dayjs('01/01/2023')}
                        onChange={(event) => handleStartDateChange(event)}
                        value={dayjs(startDate)}
                        slotProps={{
                            textField: {
                                error: false,
                            },
                        }}
                    />
                    <MobileDatePicker
                        label={'End Date'}
                        closeOnSelect={true}
                        minDate={dayjs(startDate)}
                        onChange={(event) => handleEndDateChange(event)}
                        value={dayjs(endDate)}
                        slotProps={{
                            textField: {
                                error: false,
                            },
                        }}
                    />
                </LocalizationProvider>
            </FilterSectionContainer>

            {isAdmin &&
                <>
                    <FilterSectionLabel>
                        {'Form Creator'}
                    </FilterSectionLabel>
                    <FilterSectionContainer>
                        <RadioGroup defaultValue="current-user" value={appliedFormCreatorFilter}>
                            <FormControlLabel value="current-user" control={<Radio />} label="Current User" onChange={() => setAppliedFormCreatorFilter('current-user')} />
                            <FormControlLabel value="all-users" control={<Radio sx={{ fontFamily: 'Jost' }} />} label="All Users" onChange={() => setAppliedFormCreatorFilter('all-users')} />
                        </RadioGroup>
                    </FilterSectionContainer>
                </>}

            <ButtonContainer>
                <ModalButton color={Colors.green} onClick={handleApply}>Apply</ModalButton>
                <ModalButton color={Colors.red} onClick={handleClear}>Clear</ModalButton>
            </ButtonContainer>
        </FilterAccordion>
    );
}

export default FormsFilters;